export const DISPLAY_NAME = {
  CATEGORY: 'category',
  GUEST_RATING: 'guestRating.rating',
  STAR_RATING: 'starRating.rating',
};

export const reduceAggregations = aggregationsObj => {
  const { aggregationList } = aggregationsObj || {};
  const { aggregations = [] } = aggregationList || {};

  return aggregations.reduce((result, aggregation) => {
    const { display_name, buckets } = aggregation;

    if (display_name === DISPLAY_NAME.GUEST_RATING) {
      buckets.sort((a, b) => Number(b.id) - Number(a.id));
    }

    result[display_name] = buckets;
    return result;
  }, {});
};

export const getGuestRatingLabelId = (aggregationMap, guestRating) => {
  const aggregationGuestRatings = aggregationMap[DISPLAY_NAME.GUEST_RATING];
  const rating = aggregationGuestRatings.find(
    item => Number(guestRating) >= Number(item.id)
  );

  return rating && rating.id;
};
